import React from 'react';
import '../styles/WhySection.css';
import { BRAIN_EVENT_SCHEDULE } from '../constants/eventSchedule';
import EventScheduleDetailCard from './EventScheduleDetailCard';

const WhySection = () => {
  return (
    <section className="why-section">
      <div className="container">
        {/* Header Section */}
        <div className="why-header">
          <h2 className="why-title">De ce Brain Event?</h2>
          <p className="why-description">
            Brain Event este locul unde știința întâlnește oportunitatea. Construit pentru persoane care 
            doresc conexiuni reale, protocoale concrete și momente care generează transformare. 
            Dacă ești pregătit să avansezi, Brain Event este unde trebuie să fii.
          </p>
        </div>

        {/* Event Info Card */}
        <div className="event-info-card">
          <div className="event-info-item">
            <h3 className="event-info-label">Dată</h3>
            <p className="event-info-value">{BRAIN_EVENT_SCHEDULE.date}</p>
          </div>
          <div className="event-info-item">
            <h3 className="event-info-label">Locație</h3>
            <p className="event-info-value">{BRAIN_EVENT_SCHEDULE.location}</p>
          </div>
          <div className="event-info-item">
            <h3 className="event-info-label">Acces</h3>
            <p className="event-info-value">Fizic (Standard, VIP, Ultra VIP)</p>
          </div>
        </div>

        <EventScheduleDetailCard />

        {/* Benefits Section with Tabs - Hidden */}
        {/* <div className="benefits-showcase">
          <div className="benefits-content-wrapper">
            <div className="benefits-image-wrapper">
              <img 
                src="/assets/interesati.webp" 
                alt="Brain Event Experience" 
                className="benefits-image"
              />
            </div>

            <div className="benefits-text-content">
              <h2 className="benefits-showcase-title">
                Descoperă transformarea prin neuroștiință
              </h2>
              <p className="benefits-showcase-subtitle">
                Explorează strategii dovedite științific, soluții practice pentru optimizare cognitivă 
                și experiențe care duc la rezultate măsurabile.
              </p>

              <div className="benefits-tabs">
                <button 
                  className={`benefits-tab ${activeTab === 'practical' ? 'active' : ''}`}
                  onClick={() => setActiveTab('practical')}
                >
                  Protocoale Practice
                </button>
                <button 
                  className={`benefits-tab ${activeTab === 'networking' ? 'active' : ''}`}
                  onClick={() => setActiveTab('networking')}
                >
                  Networking & Acces
                </button>
              </div>

              <div className="benefits-list">
                {benefits[activeTab].map((benefit) => (
                  <div key={benefit.number} className="benefit-item">
                    <div className="benefit-number">{benefit.number}</div>
                    <div className="benefit-content">
                      <h3 className="benefit-title">{benefit.title}</h3>
                      <p className="benefit-description">{benefit.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default WhySection;

